(function () {
  'use strict';
  var STIL = '@media (max-width: 749px) { .widget { display: none !important; } }';
  function wurzel() { var e = document.querySelector('pandectes-cmp'); return e && e.shadowRoot; }
  function setzen(r) {
    if (r.querySelector('style[data-3idee-cookie]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-3idee-cookie', '');
    s.textContent = STIL;
    r.appendChild(s);
  }
  var beobachtet = false, versuche = 0;
  function pruefen() {
    var r = wurzel();
    if (r) {
      setzen(r);
      if (!beobachtet && window.MutationObserver) { beobachtet = true; new MutationObserver(function () { setzen(r); }).observe(r, { childList: true }); }
      return true;
    }
    return false;
  }
  var uhr = setInterval(function () { if (pruefen() || ++versuche > 60) clearInterval(uhr); }, 500);
  pruefen();
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var ist = /#cookie-einstellungen$/.test(a.getAttribute('href') || '')
      || (a.closest('footer, .footer, #shopify-section-footer, [id*="footer"]') && /^\s*(cookie-?einstellungen|cookie settings)\s*$/i.test(a.textContent || ''));
    if (!ist) return;
    e.preventDefault();
    var r = wurzel(), w = r && r.querySelector('.widget');
    if (w) (w.querySelector('button') || w).click();
  });
})();
